<template>
  <q-form
    v-if="inline"
    ref="form"
    class="row q-gutter-xs"
  >
    <lwf-form-filters
      v-model="filtersModel"
      :filters="filters"
      :inline="inline"
      class="col"
    />
    <div class="col-auto">
      <q-btn-dropdown
        color="primary"
        icon="fa fa-filter"
        label="Appliquer"
        stack
        split
        @click="onApply"
      >
        <q-list>
          <q-item
            v-close-popup
            clickable
            @click="onClear"
          >
            <q-item-section avatar>
              <q-icon name="fa fa-times" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Réinitialiser</q-item-label>
            </q-item-section>
          </q-item>
          <q-item
            v-if="filtersPreset"
            v-close-popup
            clickable
            @click="onPresetSave"
          >
            <q-item-section avatar>
              <q-icon name="fa fa-save" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Sauvegarder</q-item-label>
            </q-item-section>
          </q-item>
          <q-separator />
          <q-item
            v-for="preset in filtersPreset"
            :key="preset.key"
            v-close-popup
            clickable
            @click="onPresetRestore(preset.filters)"
          >
            <q-item-section
              avatar
              @click.stop
            >
              <q-btn
                round
                flat
                dense
                icon="fa fa-ellipsis-v"
              >
                <lwf-menu
                  :context="preset"
                  :options="subMenuOptions"
                  anchor="top middle"
                  self="top right"
                />
              </q-btn>
            </q-item-section>
            <q-item-section>
              <q-item-label>{{ preset.label }}</q-item-label>
            </q-item-section>
            <q-item-section side>
              <q-icon
                v-if="preset.favorite"
                name="fa fa-star"
              />
            </q-item-section>
          </q-item>
        </q-list>
      </q-btn-dropdown>
    </div>
  </q-form>
  <q-page-sticky
    v-else
    :offset="offset"
    :position="position"
    class="z-marginals"
  >
    <q-btn
      fab
      icon="fa fa-filter"
      color="orange"
      class="pulse"
      @click="showFilters = true"
    >
      <q-badge
        floating
        color="secondary"
      >
        {{ countFilters }}
      </q-badge>
    </q-btn>
    <q-dialog v-model="showFilters">
      <q-card style="min-width: 85vw;">
        <q-card-section
          style="max-height: 90vh;"
          class="scroll"
        >
          <q-form ref="form">
            <lwf-form-filters
              v-model="filtersModel"
              :filters="filters"
              :inline="inline"
            />
          </q-form>
        </q-card-section>
        <q-card-actions align="right">
          <q-btn
            v-close-popup
            flat
            label="Réinitialiser"
            class="float-left"
            color="negative"
            @click="onClear"
          />
          <!--          <q-btn flat label="Annuler" v-close-popup/>-->
          <q-btn
            flat
            label="Filtrer"
            color="info"
            @click="onApply"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page-sticky>
</template>

<script>
import autoDefaultModelMixin from '@/mixins/autoDefaultModelMixin'
import LwfFormFilters from 'components/core/LwfFormFilters'
import { dialogConfirm } from '@/utils/ui'
import { timeId } from '@/utils/helpers'
import LwfMenu from 'components/core/LwfMenu'

export default {
  name: 'LwfFilters',
  components: { LwfMenu, LwfFormFilters },
  mixins: [autoDefaultModelMixin],
  props: {
    value: {
      type: Object,
      default: undefined
    },
    filters: {
      type: Array,
      default: undefined
    },
    filtersPreset: {
      type: Array,
      default: undefined
    },
    inline: Boolean,
    offset: {
      type: Array,
      default: () => [18, 18]
    },
    position: {
      type: String,
      default: 'bottom-right'
    }
  },
  data () {
    return {
      initialFilters: this.value,
      filtersModel: _.cloneDeep(this.value),
      showFilters: false
    }
  },
  computed: {
    subMenuOptions () {
      return [
        {
          value: 'favorite',
          leftIcon: 'fa fa-star',
          label: ({ favorite }) => favorite
            ? 'Ne plus définir par défaut'
            : 'Définir par défaut',
          cb: this.onPresetFavorite
        },
        {
          value: 'overwrite',
          leftIcon: 'far fa-save',
          label: 'Écraser',
          cb: this.onPresetOverwrite
        },
        {
          value: 'rename',
          leftIcon: 'fa fa-i-cursor',
          label: 'Renommer',
          cb: this.onPresetRename
        },
        {
          value: 'delete',
          leftIcon: 'fa fa-trash',
          label: 'Supprimer',
          cb: this.onPresetDelete
        }
      ]
    },
    countFilters () {
      return Object.values(this.filtersModel).reduce((a, f) => {
        if (Array.isArray(f) && f.length !== 0) {
          return ++a
        }
        return a
      }, 0)
    }
  },
  methods: {
    onClear () {
      this.filtersModel = _.cloneDeep(this.initialFilters)
      this.onApply()
    },
    async onApply () {
      try {
        if (await this.$refs.form.validate()) {
          this.$emit('input', _.cloneDeep(this.filtersModel))
          this.showFilters = false
        }
      } catch (e) {}
    },
    onPresetRestore (filters) {
      const _filters = Array.isArray(filters) // PHP qui nous met des array
        ? {}
        : filters
      this.filtersModel = _.cloneDeep(_filters)
      this.$emit('input', _.cloneDeep(_filters))
    },
    _savePreset (filtersPreset) {
      this.$emit('savePreset', filtersPreset)
    },
    onPresetSave () {
      dialogConfirm({
        title: 'Enregistrement du filtre',
        message: 'Veuillez choisir un titre',
        prompt: {
          model: '',
          isValid: this.$validators.required, // << here is the magic
          type: 'text' // optional
        }
      }).onOk((label) => {
        const filtersPreset = [...this.filtersPreset]
        filtersPreset.push({
          label,
          key: timeId(),
          filters: _.cloneDeep(this.filtersModel)
        })
        this._savePreset(filtersPreset)
      })
    },
    onPresetDelete (preset) {
      dialogConfirm('Le filtre ne sera plus récupérable')
        .onOk(() => {
          const filtersPreset = [...this.filtersPreset]
          filtersPreset.splice(filtersPreset.indexOf(preset), 1)
          this._savePreset(filtersPreset)
        })
    },
    onPresetRename (preset) {
      dialogConfirm({
        title: 'Renommage du filtre',
        message: 'Veuillez choisir un titre',
        prompt: {
          model: preset.label,
          isValid: this.$validators.required, // << here is the magic
          type: 'text' // optional
        }
      }).onOk((label) => {
        const filtersPreset = [...this.filtersPreset]
        filtersPreset.splice(
          filtersPreset.indexOf(preset),
          1,
          {
            ...preset,
            label
          }
        )
        this._savePreset(filtersPreset)
      })
    },
    onPresetOverwrite (preset) {
      dialogConfirm('Le filtre ne sera remplacé')
        .onOk(() => {
          const filtersPreset = [...this.filtersPreset]
          filtersPreset.splice(
            filtersPreset.indexOf(preset),
            1,
            {
              ...preset,
              filters: _.cloneDeep(this.filtersModel)
            }
          )
          this._savePreset(filtersPreset)
        })
    },
    onPresetFavorite ({ key }) {
      this._savePreset(this.filtersPreset.map(({ favorite, ...f }) => ({
        ...f,
        favorite: f.key === key
          ? favorite
            ? undefined
            : true
          : undefined
      })))
    }
  }
}
</script>
